import { Injectable } from '@angular/core';
import { dbConst } from './databaseConstants';
import { AuthService } from '../auth.service';
import { FirestoreCrudService } from './crudService';
import { Firestore } from '@angular/fire/firestore';
import { IVoucher } from 'app/models/voucher';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  private crudService: FirestoreCrudService<IVoucher>;
  constructor(
    firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<IVoucher>(firestore, authService, dbConst.vouchers);
  }

  async delete(item: IVoucher) {
    if (item.id)
      await this.crudService.delete(item.id);
  }

  getItem(id: string) {
    return this.crudService.get(id)
  }


  getItems(barId: string) {
    return this.crudService.getItems(barId);
  }


  getItemsPromise(barId: string) {
    return this.crudService.getItemsOnce(barId, "name", 100);
  }
}
